import { Renderer2, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';


declare let gapi: any;
declare const $: any;

declare const window: any;

export interface RiskifiedBeacon {
  go: (path: string) => void;
  getSessionId: () => string;
}

declare global {
  interface Window {
    RISKX?: RiskifiedBeacon;
  }
}

const RISKIFIED_SESSION_KEY = 'riskified_session_id';

@Injectable({
  'providedIn': 'root'
})
export class ScriptService {

  private riskifiedRskxReadyAttached = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private titleService: Title,
    private metaService: Meta
  ) { }

  /**
   * Append the JS tag to the Document Body.
   * @param renderer The Angular Renderer
   * @param src The path to the script
   * @returns the script element
   */
  public loadJsScript(renderer: Renderer2, src: string): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    renderer.appendChild(this.document.body, script);
    return script;
  }

  public loadAnalytics(key: string, id: string) {
    if (window != null) {
      let script = document.createElement('script');
      script.setAttribute(
        'src',
        'https://www.googletagmanager.com/gtag/js?id=' + key
      );

      script.setAttribute("id", id)


      function gtag(type, content) {
        let dataLayer = window.dataLayer ?? [];
        return dataLayer.push(arguments);
      }

      gtag('js', new Date());

      gtag('config', key);

      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }

  public loadTagManager(key: string, id: string) {
    if (window != null) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
          'gtm.start':
            new Date().getTime(), event: 'gtm.js'
        }); var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; (j as any).async = true; (j as any).src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f?.parentNode?.insertBefore(j, f);
        j.setAttribute("id", id)
      })(window, document, 'script', 'dataLayer', key);
      var noscript = document.createElement('noscript');
      let iframe = document.createElement("iframe");
      iframe.style.display = "none"
      iframe.style.visibility = "hidden"
      iframe.style.width = "0px"
      iframe.style.height = "0px"
      iframe.src = "https://www.googletagmanager.com/ns.html?id=" + id

      iframe.setAttribute("id", "eventtagf")

      noscript.appendChild(iframe)

      this.document.getElementsByTagName("body")[0].insertBefore(noscript, document.body.firstChild)

    }
  }

  removeTagManager(idt: string) {
    for (let id = 0; id < document.getElementsByTagName('script').length; id++) {
      if (document.getElementsByTagName('script')[id].src != null && document.getElementsByTagName('script')[id].id == idt) {
        document.getElementsByTagName('script')[id].remove()
      }
    }
  }

  removeTagManageriFrame(idt: string) {
    for (let id = 0; id < document.getElementsByTagName('iframe').length; id++) {
      if (document.getElementsByTagName('iframe')[id].src != null && document.getElementsByTagName('iframe')[id].id == idt) {
        document.getElementsByTagName('iframe')[id].remove()
      }
    }
  }

  public removeAnalytics(idt: string) {
    for (let id = 0; id < document.getElementsByTagName('script').length; id++) {
      if (document.getElementsByTagName('script')[id].src != null && document.getElementsByTagName('script')[id].id == idt) {
        document.getElementsByTagName('script')[id].remove()
      }
    }
  }

  public defineDefaultMeta() {
    this.titleService.setTitle(environment.title);
    this.metaService.updateTag({ property: 'og:title', content: environment.ogTitle });
    this.metaService.updateTag({ name: 'description', content: environment.description });

    this.metaService.updateTag({ property: 'og:image', content: environment.ogImage });
  }

  getRiskifiedSessionId(): string | null {
    const sid = sessionStorage.getItem(RISKIFIED_SESSION_KEY);
    if (!sid) {
      return null;
    }
    return sid.length > 100 ? sid.substring(0, 100) : sid;
  }

  loadRiskifiedBeacon(storeDomain: string): void {
    if (this.document.querySelector('script[src*="beacon.riskified.com"]')) {
      return;
    }

    const loadBeacon = () => {
      if (this.document.querySelector('script[src*="beacon.riskified.com"]')) {
        return;
      }
      const url = 'https://beacon.riskified.com?shop=' + encodeURIComponent(storeDomain);
      const script = this.document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = url;

      const storeSessionId = (sessionId: string) => {
        const value = sessionId.length > 100 ? sessionId.substring(0, 100) : sessionId;
        sessionStorage.setItem(RISKIFIED_SESSION_KEY, value);
      };

      if (!this.riskifiedRskxReadyAttached) {
        this.riskifiedRskxReadyAttached = true;
        this.document.addEventListener('rskx_ready', ((event: CustomEvent) => {
          const sessionId = event.detail?.sessionId;
          if (sessionId) {
            storeSessionId(sessionId);
          }
        }) as EventListener);
      }

      script.onerror = (error) => {
        console.error('[Riskified] Erro ao carregar beacon:', {
          url,
          storeDomain,
          error,
          message: 'Verifique se o domínio está registrado no painel Riskified',
        });
      };

      const head = this.document.head || this.document.getElementsByTagName('head')[0];
      if (head) {
        head.appendChild(script);
      } else {
        const body = this.document.body || this.document.getElementsByTagName('body')[0];
        body?.appendChild(script);
      }
    };

    if (typeof window !== 'undefined' && this.document.readyState !== 'complete') {
      window.addEventListener('load', loadBeacon, false);
      return;
    }
    loadBeacon();
  }
}